// Q&A data for Mirage Foods

export const qaItems = [
  {
    question: 'What are the advantages of using Mirage bases and mixes?',
    answer: [
      'Reduce prep time',
      'Reduce cost per serving',
      'Very reliable results',
      'Quality desserts',
      'Long shelf life',
      'Less labor required'
    ]
  },
  {
    question: 'How do Mirage mixes and bases come packed?',
    answer: 'Most products are shipped in bulk in HD corrugated cases of 25 lbs poly bag in box or 5 x 5lbs foil-sealed bags. Case weight is typically 25 lbs.'
  },
  {
    question: 'Are there other size options?',
    answer: 'Yes! We are a service-oriented company that accommodates a variety of packaging options. We provide custom solutions for unique needs.'
  },
  {
    question: 'What is Mirage pricing based upon?',
    answer: 'Pricing is based on the cost and rarity of ingredients, volume of purchase, shipping/freight points, and packaging requirements.'
  },
  {
    question: 'What about custom orders?',
    answer: 'Yes! Mirage is a custom and private label manufacturer. We can work on special dessert projects tailored to your needs.'
  },
  {
    question: 'What about your manufacturing facility?',
    answer: 'We have been manufacturing for over 25 years with no product complaints from loyal customers. 25+ years of proven excellence!'
  }
];
